import "objectFitPolyfill";
import Stickyfill from "stickyfilljs";
import "classlist-polyfill";
import svg4everybody from "svg4everybody";

// polyfill for .closest
(function (ELEMENT) {
	ELEMENT.matches = ELEMENT.matches || ELEMENT.mozMatchesSelector || ELEMENT.msMatchesSelector || ELEMENT.oMatchesSelector || ELEMENT.webkitMatchesSelector;
	ELEMENT.closest = ELEMENT.closest || function closest(selector) {
		if (!this) return null;
		if (this.matches(selector)) return this;
		if (!this.parentElement) {
			return null
		} else return this.parentElement.closest(selector)
	};
}(Element.prototype));

(function (arr) {
	arr.forEach(function (item) {
		if (item.hasOwnProperty('append')) {
			return;
		}
		Object.defineProperty(item, 'append', {
			configurable: true,
			enumerable: true,
			writable: true,
			value: function append() {
				let argArr = Array.prototype.slice.call(arguments),
					docFrag = document.createDocumentFragment();

				argArr.forEach(function (argItem) {
					let isNode = argItem instanceof Node;
					docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
				});

				this.appendChild(docFrag);
			}
		});
	});
})([Element.prototype, Document.prototype, DocumentFragment.prototype]);

Stickyfill.add(document.querySelectorAll('.hash-menu__wrapper'));

objectFitPolyfill(document.querySelectorAll('[data-object-fit]'));

const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
if (isIE11) {
	svg4everybody({
		polyfill: true // polyfill <use> elements for External Content
	});
}

// 100vh fix
const appHeight = () => {
	const doc = document.documentElement
	doc.style.setProperty('--app-height', `${window.innerHeight}px`)
}
window.addEventListener('resize', () => {
	if (window.innerWidth > 1024) appHeight();
});
appHeight();
